import React, {ReactElement, useState} from "react";
import {Button, IconButton, InputBase, TextField, Typography, useTheme} from "@mui/material";
import {CommentOutlined, DeleteOutlined, SendOutlined} from "@mui/icons-material";
import {DIVIDER, PD_MD, PD_SM, PD_XSM} from "@/shared/dimens";
import {colorYellow, mediumGray} from "@/shared/colors";
import {CommentElement} from "../types";
import {StyledBoxRow} from "../../../../shared/StyledComponents";

function formatTime(timestamp: number): string {
  const d = new Date(timestamp);
  return d.toLocaleString(undefined, {month: "short", day: "numeric", hour: "2-digit", minute: "2-digit"});
}

export function CommentsSidebarView({comments, onAdd, onDelete, onSelect}: {
  comments: CommentElement[],
  onAdd: (text: string) => void,
  onDelete: (id: string) => void,
  onSelect: (id: string) => void,
}): ReactElement {
  const [input, setInput] = useState("");
  return <div style={{display: "flex", flexDirection: "column", flexGrow: 1, overflow: "hidden"}}>
    <div style={{flexGrow: 1, overflow: "auto", padding: `${PD_SM}px 0`}}>
      {comments.length === 0 && (
        <Typography variant="body2" style={{color: mediumGray, padding: PD_SM, textAlign: "center"}}>
          No comments yet
        </Typography>
      )}
      {comments.map(comment => <div key={comment.id} style={{display:"flex", flexDirection: "column", padding: PD_SM, borderBottom:DIVIDER}}>
        <div
          onClick={() => onSelect(comment.id)}
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: PD_SM,
            padding: `${PD_SM}px ${PD_MD}px`,
            cursor: "pointer",
          }}
          onMouseEnter={e => (e.currentTarget.style.background = mediumGray + "18")}
          onMouseLeave={e => (e.currentTarget.style.background = "")}
        >
          <CommentOutlined style={{fontSize: 16, color: colorYellow, marginTop: 2}}/>
          <div style={{flexGrow: 1, minWidth: 0}}>
            <Typography variant="body2" style={{wordBreak: "break-word"}}>{comment.text}</Typography>
            <Typography variant="caption" style={{color: mediumGray}}>{formatTime(comment.timestamp)}</Typography>
          </div>
          <IconButton
            size="small"
            onClick={e => { e.stopPropagation(); onDelete(comment.id); }}
            style={{padding: 2, flexShrink: 0}}
          >
            <DeleteOutlined style={{fontSize: 16, color: mediumGray}}/>
          </IconButton>
        </div>
        {/*<StyledBoxRow style={{alignItems:'center', padding: `0px ${PD_SM}px`}}>*/}
        {/*  <TextField size={"small"} style={{flexGrow: 1}} InputProps={{style: {height: 32}}} placeholder={"Add a reply..."}/>*/}
        {/*  <Button size="small" variant={"contained"}>Save</Button>*/}
        {/*</StyledBoxRow>*/}
      </div>)}
    </div>
    <div style={{
      display: "flex",
      alignItems: "center",
      gap: PD_SM,
      padding: `${PD_SM}px ${PD_MD}px`,
      borderTop: `1px solid ${mediumGray}33`,
    }}>
      <InputBase
        placeholder="Add a comment..."
        value={input}
        onChange={e => setInput(e.target.value)}
        onKeyDown={e => {
          if (e.key === "Enter" && input.trim()) {
            onAdd(input.trim());
            setInput("");
          }
        }}
        style={{flexGrow: 1, fontSize: 14}}
      />
      <IconButton
        size="small"
        disabled={!input.trim()}
        onClick={() => {
          if (input.trim()) {
            onAdd(input.trim());
            setInput("");
          }
        }}
      >
        <SendOutlined style={{fontSize: 18}}/>
      </IconButton>
    </div>
  </div>;
}
